import AuthContext from './AuthContext'

const AuthConsumer = AuthContext.Consumer

export default AuthConsumer